var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.additionalIncomeAmountVisible ||
    _vm.additionalIncomeDescriptionVisible ||
    _vm.additionalIncomeTypeVisible ||
    _vm.additionalIncomeIncomePeriodVisible
      ? _c(
          "span",
          [
            _c("section-title", { staticClass: "mt-2" }, [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.applicantName) +
                  ",\n      " +
                  _vm._s(
                    _vm.$t(
                      "application-standalone.pages.incomeHistory.tellUsAboutYourIncomeFromOutsideJob"
                    )
                  ) +
                  "\n    "
              ),
            ]),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.additionalIncomeTypeVisible
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "page-section-group-layout",
                          [
                            _c(
                              "section-title",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-standalone.questions.otherIncome.additionalIncomeType"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _vm.getValidator(
                                  "additionalIncomeType.required"
                                )
                                  ? _c("input-required-indicator")
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("select-field", {
                              attrs: {
                                value: _vm.additionalIncomeType,
                                placeholder: _vm.$t(
                                  "application-form.income-type"
                                ),
                                options: _vm.additionalIncomeTypeOptions,
                                validator: _vm.getValidator(
                                  "additionalIncomeType"
                                ),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.additionalIncomeType = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.additionalIncomeIncomePeriodVisible
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "page-section-group-layout",
                          [
                            _c(
                              "section-title",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-standalone.questions.otherIncome.additionalIncomePeriod"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _vm.getValidator(
                                  "additionalIncomeIncomePeriod.required"
                                )
                                  ? _c("input-required-indicator")
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("select-field", {
                              attrs: {
                                value: _vm.additionalIncomeIncomePeriod,
                                placeholder: _vm.$t(
                                  "application-form.income-period"
                                ),
                                options: _vm.applicantIncomePeriodOptions,
                                validator: _vm.getValidator(
                                  "additionalIncomeIncomePeriod"
                                ),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.additionalIncomeIncomePeriod = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "b-row",
              [
                _vm.additionalIncomeAmountVisible
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "page-section-group-layout",
                          [
                            _c(
                              "section-title",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-standalone.questions.otherIncome.additionalIncomeAmount"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _vm.getValidator(
                                  "additionalIncomeAmount.required"
                                )
                                  ? _c("input-required-indicator")
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("currency-field", {
                              attrs: {
                                value: _vm.additionalIncomeAmount,
                                validator: _vm.getValidator(
                                  "additionalIncomeAmount"
                                ),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.additionalIncomeAmount = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.additionalIncomeDescriptionVisible
                  ? _c(
                      "b-col",
                      { attrs: { cols: "12" } },
                      [
                        _c(
                          "page-section-group-layout",
                          [
                            _c(
                              "section-title",
                              [
                                _vm._v(
                                  "\n            " +
                                    _vm._s(
                                      _vm.$t(
                                        "application-standalone.questions.otherIncome.additionalIncomeDescription"
                                      )
                                    ) +
                                    "\n            "
                                ),
                                _vm.getValidator(
                                  "additionalIncomeDescription.required"
                                )
                                  ? _c("input-required-indicator")
                                  : _vm._e(),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c("text-field", {
                              attrs: {
                                value: _vm.additionalIncomeDescription,
                                placeholder: _vm.$t(
                                  "application-form.description"
                                ),
                                validator: _vm.getValidator(
                                  "additionalIncomeDescription"
                                ),
                              },
                              on: {
                                "update:value": function ($event) {
                                  _vm.additionalIncomeDescription = $event
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        )
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }